import React from 'react';
import './leistungen.css';

export default function Leistungen(){
  return (
    <main className="catalog">
      <section className="catalog-hero">
        <div className="hero-inner">
          <h1>Unsere Speisekarte</h1>
          <p className="lead">Verschiedene Smashburger, kreative Pommes-Kreationen und verführerische Desserts — frisch zubereitet für dein Event.</p>
        </div>
      </section>

      <section className="catalog-grid">
        <div className="catalog-card">
          <h3>Burger</h3>
          <p>Classic, Cheese, BBQ, Spicy, Veggie & mehr.</p>
          <div className="card-gallery">
            <div className="gallery-img" role="img" aria-label="Classic Smashburger" style={{backgroundImage: `url(https://images.unsplash.com/photo-1550547660-d9450f859349?q=80&w=1200&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Cheese Burger" style={{backgroundImage: `url(https://images.unsplash.com/photo-1568901346375-23c9450c58cd?q=80&w=800&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Veggie Burger" style={{backgroundImage: `url(https://images.unsplash.com/photo-1606755962772-3c7b9f0b6d7b?q=80&w=800&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Smashburger Closeup" style={{backgroundImage: `url(https://images.unsplash.com/photo-1546069901-ba9599a7e63c?q=80&w=800&auto=format&fit=crop)`}} />
          </div>
        </div>

        <div className="catalog-card">
          <h3>Pommes & Sides</h3>
          <p>Klassisch, Loaded Fries, Truffle Fries, Süßkartoffel & Dips.</p>
          <div className="card-gallery">
            <div className="gallery-img" role="img" aria-label="Pommes" style={{backgroundImage: `url(https://images.unsplash.com/photo-1541599540903-216a46caad11?q=80&w=1200&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Loaded Fries" style={{backgroundImage: `url(https://images.unsplash.com/photo-1551782450-a2132b4ba21d?q=80&w=800&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Truffle Fries" style={{backgroundImage: `url(https://images.unsplash.com/photo-1504544750208-dc0358e63f7f?q=80&w=800&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Sweet Potato Fries" style={{backgroundImage: `url(https://images.unsplash.com/photo-1525755662778-989d0524087e?q=80&w=800&auto=format&fit=crop)`}} />
          </div>
        </div>

        <div className="catalog-card">
          <h3>Desserts</h3>
          <p>Cheesecake, Tiramisu, Ice-Cream Sandwiches & Sweet Bites.</p>
          <div className="card-gallery">
            <div className="gallery-img" role="img" aria-label="Cheesecake" style={{backgroundImage: `url(https://images.unsplash.com/photo-1543352634-8f0f99e1d9d2?q=80&w=1200&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Tiramisu" style={{backgroundImage: `url(https://static01.nyt.com/images/2017/04/05/dining/05COOKING-TIRAMISU1/05COOKING-TIRAMISU1-videoSixteenByNineJumbo1600.jpg)`}} />
            <div className="gallery-img" role="img" aria-label="Ice Cream" style={{backgroundImage: `url(https://images.unsplash.com/photo-1604908177522-9b5c6e1b9b2b?q=80&w=800&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Sweet Bites" style={{backgroundImage: `url(https://images.unsplash.com/photo-1505250469679-203ad9ced0cb?q=80&w=800&auto=format&fit=crop)`}} />
          </div>
        </div>

        <div className="catalog-card">
          <h3>Getränke & Extras</h3>
          <p>Softdrinks, Limos, Kaffee, sowie Geschirr & Personal auf Anfrage.</p>
          <div className="card-gallery">
            <div className="gallery-img" role="img" aria-label="Limonade" style={{backgroundImage: `url(https://images.unsplash.com/photo-1509042239860-f550ce710b93?q=80&w=1200&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Cocktail" style={{backgroundImage: `url(https://images.unsplash.com/photo-1505576391880-6c5b0b0f2e2b?q=80&w=800&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Kaffee" style={{backgroundImage: `url(https://images.unsplash.com/photo-1523942839745-784b7d1a4b3b?q=80&w=800&auto=format&fit=crop)`}} />
            <div className="gallery-img" role="img" aria-label="Extras" style={{backgroundImage: `url(https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=800&auto=format&fit=crop)`}} />
          </div>
        </div>
      </section>
    </main>
  );
}
